// extracted by mini-css-extract-plugin
export var parcelRow = "_u2-0";